module.exports = __webpack_public_path__ + "img/assistance_share_btn_img.fe39d970.png";